import { FilterChip } from "@/components/search-filter/FilterChip";
import { useContext } from "react";
import {
  PriceListFilterContext,
  PriceListFilterContextType,
} from "./PriceListFilterContext";

export const PriceListFilterChips = () => {
  const { selectedFilterChips, setFilterIsOpen, setOpenSectionIds } =
    useContext(PriceListFilterContext) as PriceListFilterContextType;

  return (
    <>
      {selectedFilterChips.map((filterChip) => (
        <FilterChip
          key={filterChip.label + filterChip.sectionId}
          label={filterChip.label}
          onClickHandler={() => {
            setOpenSectionIds([filterChip.sectionId]);
            setFilterIsOpen(true);
          }}
        />
      ))}
    </>
  );
};
